import { Component, OnInit } from '@angular/core';

interface data {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ops-revenue-share',
  templateUrl: './ops-revenue-share.component.html',
  styleUrls: ['./ops-revenue-share.component.css']
})
export class OpsRevenueShareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  custs: data[] = [
    {value:'FREEDOM-1',viewValue:'FREEDOM'},
    {value:'XOME-2',viewValue:'XOME'},
    {value:'PROTECK-3',viewValue:'PROTECK'},
    {value:'BK EMPOWER-4',viewValue:'BK EMPOWER'},
    {value:'FREEDOM XPANSE-5',viewValue:'FREEDOM XPANSE'},
  ];

  public ShowFilters: boolean = true;
  public buttonName: any = 'Show Filters';

  toggle() {
    this.ShowFilters = !this.ShowFilters;
    if (this.ShowFilters)
      this.buttonName = "Hide Filters";
    else
      this.buttonName = "Show Filters";
  }


}
